import './jquery/jquery-qrcode.min.js'
import './jquery/jquery.slimscroll.min.js'
import './jquery/inputmask.binding.js'

// зависимости проекта
import './store.js'
import './menu.js'
import './collapse.js'
import './scroll-alphabet.js'
import './register-list.js'
import './calcposobie.js'
import './main.js'
import './events.js'
import './hmenu.js'
import './banner.js'
import './getapp.js'
import './invalid.js'
import './form.js'
import './click-outside.js'
import './calc.js'
import './questions.js'
// eof зависимости проекта

// импорт должен быть последним
import './app.js'
